class Menu {
	/**
	 * @param {HTMLElement} element - The menu element
	 */
	constructor(element) {
		this.element = element;
		this.isOpen = false;

		// Get close buttons (multiple for mobile/desktop) and overlay
		this.closeButtons = element.querySelectorAll(".js-HeaderMenuClose");
		this.overlay = element.querySelector(".HeaderMenu-overlay");

		// Get accordion buttons
		this.accordionButtons = element.querySelectorAll(".js-HeaderMenuAccordion");

		// Bind event listeners to all close buttons
		this.closeButtons.forEach((button) => {
			button.addEventListener("click", () => this.close());
		});

		if (this.overlay) {
			this.overlay.addEventListener("click", () => this.close());
		}

		// Close on escape key
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape" && this.isOpen) {
				this.close();
			}
		});

		// Initialize accordions
		this.initAccordions();
	}

	/**
	 * Initialize accordion behavior
	 */
	initAccordions() {
		this.accordionButtons.forEach((button) => {
			button.addEventListener("click", (e) => {
				e.preventDefault();
				this.toggleAccordion(button);
			});
		});
	}

	/**
	 * Toggle accordion state
	 * @param {HTMLElement} button - The accordion button
	 */
	toggleAccordion(button) {
		const isExpanded = button.getAttribute("aria-expanded") === "true";
		const submenu = button.parentElement.querySelector(
			".HeaderMenuNav-submenu",
		);

		if (!submenu) return;

		// Toggle state
		button.setAttribute("aria-expanded", (!isExpanded).toString());

		if (isExpanded) {
			submenu.classList.remove("HeaderMenuNav-submenu--expanded");
		} else {
			submenu.classList.add("HeaderMenuNav-submenu--expanded");
		}
	}

	/**
	 * Open the menu
	 */
	open() {
		this.isOpen = true;
		this.element.removeAttribute("hidden");
		document.body.style.overflow = "hidden";
	}

	/**
	 * Close the menu
	 */
	close() {
		this.isOpen = false;
		this.element.setAttribute("hidden", "");
		document.body.style.overflow = "";
	}

	/**
	 * Toggle the menu
	 */
	toggle() {
		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	}
}

export default Menu;
